import React from 'react';
import { useNavigation } from '@react-navigation/native';
import { useShallow } from 'zustand/react/shallow';
import { PosVariousModal } from './PosVariousModal';
import { usePosOverlayStore } from '../../store/usePosOverlayStore';
import { usePosStore } from '../../store/usePosStore';
import { useBranchPermission } from '../../../shell/session/hooks/useBranchPermission';
import { usePosVariosItem } from '../../screens/hooks/usePosVariosItem';

export const PosVariousModalContainer = () => {
  const navigation = useNavigation<any>();
  const { canEdit } = useBranchPermission('POS');
  const addCustomItemToCart = usePosStore((s) => s.addCustomItemToCart);
  const updateCustomCartLine = usePosStore((s) => s.updateCustomCartLine);

  const { variosVisible, variosName, variosAmount, editingCustomLineId } = usePosOverlayStore(
    useShallow((s) => ({
      variosVisible: s.variosVisible,
      variosName: s.variosName,
      variosAmount: s.variosAmount,
      editingCustomLineId: s.editingCustomLineId,
    })),
  );

  const setVariosName = usePosOverlayStore((s) => s.setVariosName);
  const setVariosAmount = usePosOverlayStore((s) => s.setVariosAmount);
  const closeVarios = usePosOverlayStore((s) => s.closeVarios);

  const { variosSaving, saveVariousItem, ConfirmModal } = usePosVariosItem({
    canEdit,
    variosName,
    variosAmount,
    editingCustomLineId,
    closeVarios,
    addCustomItemToCart,
    updateCustomCartLine,
    navigation,
  });

  return (
    <>
      <PosVariousModal
        visible={variosVisible}
        name={variosName}
        amount={variosAmount}
        isEditing={editingCustomLineId != null}
        onClose={closeVarios}
        onChangeName={setVariosName}
        onChangeAmount={setVariosAmount}
        onSave={saveVariousItem}
        saving={variosSaving}
      />
      {ConfirmModal}
    </>
  );
};
